import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import type * as models from '../models'

/**
 * Resets the initial state whenever the {@link models.page.Rendering.Context}
 * changes.
 */
export const setContext = store.effects.create((feature: Feature) =>
  feature.selectors.context.asObservable.pipe(
    // NOTE: We dispatch `setContext` immediately when context changes to avoid
    // a flash of stale content. This is a temporary workaround because
    // `triggerPageRendering` is debounced (500 ms). Separating the concerns
    // allows the UI to respond promptly while still throttling heavy rendering
    // logic.
    rxjs.map(context =>
      feature.actions.setContext.from('setContext (effect)').create(context),
    ),
  ),
)
